export function getNextOrFirstElementIndexByLetter(
    options: any[],
    labelKey: string,
    letter: string,
    lastIndex = -1,
): undefined | number {
    const uppercaseLetter = letter.toUpperCase();
    const normalizedValueBeginsWithLetter = (value: string) => value.normalize('NFD')
        .toUpperCase()
        .startsWith(uppercaseLetter);

    const getSearchedElementAfterIndex = (targetIndex: number) =>
        options.findIndex((option, index) =>
            normalizedValueBeginsWithLetter(option[labelKey])
            && index > targetIndex,
        );

    let optionIndex = getSearchedElementAfterIndex(lastIndex);

    // No value after index found, perform search from beginning
    if (optionIndex === -1) {
        optionIndex = getSearchedElementAfterIndex(-1);
    }

    return optionIndex === -1 ? undefined : optionIndex;
}

export function isPointInsideRect(point: DOMPoint, rect: DOMRect): boolean {
    return point.y >= rect.top
        && point.y <= rect.bottom
        && point.x >= rect.left
        && point.x <= rect.right;
}

export function isRectVerticallyContainedInOtherRect(
    targetRect: DOMRect,
    containerRect: DOMRect,
    offset = 0,
): boolean {
    return targetRect.top >= containerRect.top - offset
        && targetRect.bottom <= containerRect.bottom + offset;
}
